import React, { createContext, useContext } from 'react'
import { useRouter } from '../../../hooks/useRouter'

const CommandRouteContext: React.Context<CommandRouteProvider> =
  createContext<CommandRouteProvider>({
    handleRoute: () => {},
  })

export const ProvideCommandRoute = ({
  onRoute = () => {},
  children,
}: React.PropsWithChildren<any>): React.ReactElement => {
  const value: CommandRouteProvider = useProvideCommandReroute({ handleRoute: onRoute })
  return <CommandRouteContext.Provider value={value}>{children}</CommandRouteContext.Provider>
}

export const useCommandReroute = (): CommandRouteProvider => {
  return useContext<CommandRouteProvider>(CommandRouteContext)
}

export interface CommandRouteProvider {
  handleRoute: Function
}

export const useProvideCommandReroute = ({
  handleRoute: _handleRoute,
}: CommandRouteProvider): CommandRouteProvider => {
  const router = useRouter()
  const handleRoute = (path: string) => {
    router.push(path)
    _handleRoute()
  }
  return {
    handleRoute,
  }
}
